module.exports = __webpack_public_path__ + "img/15_24.9c81ef4c.png";